import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Select from '../../form/Select';
import { optionsTemplate } from '../../../utils/formatters';

class TourForm extends React.Component {

    render() {console.log(this.props)

        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="tour"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Túra"
                        />
                    </div>
                    <div className="col-sm-8">
                    <ComponentField
                        getFieldProps={this.props.getFieldProps}
                        componentConfig={this.props.componentConfig}
                        name="partner"
                        filter={{field: "booklog_api_id", operator: "not isnull"}}
                        storeType="local"
                        values={this.props.values}
                        setFieldValue={this.props.setFieldValue}
                        label="Partner"
                    />
                    </div>
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="shipping_provider"
                            values={this.props.values}
                            label="Szállító"
                            setFieldValue={(field, value) => {
                                this.props.setFieldValue(field, value ? value : null)
                            }}
                        />
                    </div>
                    {this.props.values?.partner?.partner_id && <div className="col-sm-6">
                        <Select
                            component="apilocation"
                            name="location"
                            filter={{field: "client", value: this.props.values.partner.partner_id}}
                            label="Szállítás helye"
                            labelKey="name"
                            storeType="local"
                            optionsTemplate={optionsTemplate("location")}
                            objectValue={false}
                            value={this.props.values.location}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>}
                </div>
            </form>
        );
    }
}

export default createForm(TourForm);